<!-- <div class="page-container flex items-center justify-center min-h-[calc(100vh-4rem)] bg-white">
  <div class="relative w-full max-w-md border border-dc-navy mt-10"> -->
   

<div class="flex items-center justify-center min-h-[calc(100vh-4rem)] bg-white px-4">
  <div class="relative w-full max-w-[400px] border border-dc-navy mt-10">
    <div class="form-card px-6 xl:!pr-6 xl:!pl-6">
      <div class="mx-auto w-full max-w-lg">
        <h1 class="text-3xl font-bold text-center text-dc-navy mb-8">
          {{ 'LOGIN_TITLE' | translate }}
        </h1>

        <form [formGroup]="loginForm" (ngSubmit)="login()">
          <div class="field-control">
            <label class="field-label font-bold">{{ 'LOGIN_USERNAME' | translate }}</label>
            <app-text-field
              [label]="''"
              [hideLabel]="true"
              [control]="loginForm.get('username')!"
              [maxlength]="80"
            ></app-text-field>
          </div>
          <div class="field-control">
            <label class="field-label font-bold">{{ 'LOGIN_PASSWORD' | translate }}</label>
            <app-text-field
              [label]="''"
              [hideLabel]="true"
              [type]="'password'"
              [showPasswordToggle]="true"
              [control]="loginForm.get('password')!"
              [maxlength]="128"
            ></app-text-field>
          </div>

          <div class="text-center mb-6 text-dc-navy">
            <span>{{ 'LOGIN_FORGOT_PREFIX' | translate }}</span>
            <button type="button" class="underline" (click)="goToForgotUsername()">
              {{ 'LOGIN_FORGOT_USERNAME' | translate }}
            </button>
            <span>{{ 'LOGIN_FORGOT_OR' | translate }}</span>
            <button type="button" class="underline" (click)="goToForgotPassword()">
              {{ 'LOGIN_FORGOT_PASSWORD' | translate }}
            </button>
            <span>{{ 'LOGIN_FORGOT_SUFFIX' | translate }}</span>
          </div>

          @if (loginError) {
            <div class="mb-6">
              <app-validation-message
                [type]="'error'"
                [content]="{
                  title: loginError | translate,
                  message: 'LOGIN_INVALID_MESSAGE' | translate
                }"
                [showbutton]="false"
              ></app-validation-message>
            </div>
          }

          <div class="field-control mb-2!">
            <app-button
              type="submit"
              classesName="btn-primary-big w-full"
              class="block"
              [label]="'LOGIN_AGAIN' | translate"
              [disabled]="isSubmitting"
            ></app-button>
          </div>
        </form>

        <div class="flex items-center gap-2 my-4">
          <span class="flex-1 h-px bg-gray-300"></span>
          <span class="text-dc-navy text-sm">{{ 'LOGIN_OR' | translate }}</span>
          <span class="flex-1 h-px bg-gray-300"></span>
        </div>

        <div class="field-control mb-4">
          <button
            type="button"
            class="w-full bg-black px-20"
            [disabled]="uaePassSubmitting"
            (focus)="onUaePassFocus()"
            (blur)="onUaePassBlur()"
            (pointerdown)="onUaePassPress(true)"
            (pointerup)="onUaePassPress(false)"
            (pointerleave)="onUaePassPress(false)"
            (keydown)="onUaePassKey(true, $event)"
            (keyup)="onUaePassKey(false, $event)"
            (click)="loginWithUaePass()"
          >
            <img [src]="uaePassImage" [alt]="'LOGIN_UAE_PASS' | translate" class="w-full h-auto" />
          </button>
        </div>

        <div class="field-control mt-0 mb-1!">
            <app-button
              type="button"
              classesName="card-edge-cut-white btn-primary-big"
              [label]="'LOGIN_CREATE_ACCOUNT' | translate"
              (onBtnClick)="createAccount()"
            ></app-button>
        </div>
      </div>
    </div>
  </div>
</div>

@if (showMfaOtpModal) {
  <app-mfa-email-otp
    [flowId]="pendingMfaFlowId"
    [authenticatorId]="pendingMfaAuthenticatorId"
    [maskedEmail]="mfaMaskedEmail"
    (verified)="onMfaOtpVerified()"
    (closed)="onMfaOtpClosed()"
  ></app-mfa-email-otp>
}
